import { selfExclusion } from "@actions/auth";
import { getUserInfo } from "@actions/profile";
import { getUser } from "@utils";
import moment from "moment";
import React, { memo, useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { BettoPrimaryButton } from "../BettoButton";
import {
	ExcludedInfo,
	ExcludedNotice,
	ExclusionDescription,
	ExclusionForm,
	ExclusionRoot,
	FieldGroup,
	FieldLabel,
	NumberInput,
} from "./elements";

export const BettoSelfExclusion = memo(({ translate, selfExclusion, getUserInfo }) => {
	const [selfExcluded, setSelfExcluded] = useState(false);
	const [selfExclusionDays, setSelfExclusionDays] = useState(0);
	const [selfExclusionStartDate, setSelfExclusionStartDate] = useState(0);
	const [days, setDays] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);

	const loadProfile = useCallback(() => {
		const fetchedUser = getUser();
		if (!fetchedUser) return;

		getUserInfo((res) => {
			setSelfExcluded(!!res?.self_excluded);
			setSelfExclusionDays(res?.self_exclusion_days || 0);
			setSelfExclusionStartDate(res?.self_exclusion_start || 0);
		});
	}, [getUserInfo]);

	useEffect(() => {
		loadProfile();
	}, [loadProfile]);

	const handleSubmit = useCallback(
		(event) => {
			event.preventDefault();
			if (!days || !/^[0-9]+$/.test(days)) return;

			setIsSubmitting(true);
			selfExclusion({ selfExculsionDays: days, isSelfExcluded: true }, () => {
				setIsSubmitting(false);
				setDays("");
				loadProfile();
			});
		},
		[days, loadProfile, selfExclusion]
	);

	const isValidDays = /^[0-9]+$/.test(days) && Number(days) >= 1 && Number(days) <= 1825;

	if (selfExcluded) {
		return (
			<ExclusionRoot>
				<ExcludedNotice>
					{translate("selfExclusion.notice", {
						date: moment(selfExclusionStartDate).format("DD.MM.YYYY, HH:mm"),
						day: selfExclusionDays,
					})}
				</ExcludedNotice>
				<ExcludedInfo>{translate("SELF_EXCLUSION_INFO")}</ExcludedInfo>
			</ExclusionRoot>
		);
	}

	return (
		<ExclusionRoot>
			<ExclusionDescription>{translate("SELF_EXCLUSION_DESC")}</ExclusionDescription>
			<ExclusionForm onSubmit={handleSubmit}>
				<FieldGroup>
					<FieldLabel>{translate("FOR_DAYS")}</FieldLabel>
					<NumberInput
						type="number"
						min={1}
						max={1825}
						value={days}
						onChange={(event) => setDays(event.target.value)}
					/>
				</FieldGroup>
				<BettoPrimaryButton type="submit" disabled={!isValidDays || isSubmitting}>
					{translate("EXCLUDE NOW")}
				</BettoPrimaryButton>
			</ExclusionForm>
		</ExclusionRoot>
	);
});

BettoSelfExclusion.displayName = "BettoSelfExclusion";

BettoSelfExclusion.propTypes = {
	translate: PropTypes.func.isRequired,
	selfExclusion: PropTypes.func,
	getUserInfo: PropTypes.func,
};

const mapDispatchToProps = { selfExclusion, getUserInfo };

export default connect(null, mapDispatchToProps)(BettoSelfExclusion);
